import React, {useState} from 'react';

import {LoadingOverlay} from "../../../components/LoadingOverlay";
import {OptionalContent} from "../../../components/OptionalContent";
import {DateFormatter} from "../../../services/date";
import {useAvailabilityQuery} from "../query";
import {
    availableAccommodationUnitPricesMapper,
    bookingVariantMapper,
} from "../../../mapper/bookingMapper";
import BookingVariantsList from "./BookingVariantsList";
import PriceList from "./PriceList";
import SearchForm from "./SearchForm";

import Container from "@mui/material/Container";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";


const noSearchMessage = "Imposta i filtri per cercare le strutture disponibili"

const Availabilities = ({accommodations}) => {
    const [options, setOptions] = useState(null);
    const availabilityQuery = useAvailabilityQuery(options);

    const bookingVariants = availabilityQuery.data ? availabilityQuery.data.bookingVariants.map(bv => bookingVariantMapper(bv)) : [];
    const flexDateBookingVariants = availabilityQuery.data ? availabilityQuery.data.flexDateBookingVariants.map(ap => bookingVariantMapper(ap)) : [];
    const availableAccommodationUnitPrices = availabilityQuery.data ? availabilityQuery.data.availableAccommodationUnitPrices.map(ap => availableAccommodationUnitPricesMapper(ap)) : [];

    const handleSubmit = async values => {
        setOptions({
            ...values,
            ...{
                arrival: DateFormatter.onlyDateISOString(values.arrival, null),
                departure: DateFormatter.onlyDateISOString(values.departure, null)
            }
        })
    }

    return (
        <Container maxWidth='md' disableGutters sx={{p: 2}}>
            <Card>
                <CardContent sx={{display: 'flex', flexDirection: 'column', minHeight: '600px'}}>
                    <SearchForm onSubmit={handleSubmit}/>
                    <LoadingOverlay isLoading={!!options && availabilityQuery.isLoading}>
                        <OptionalContent hasContent={availabilityQuery.data !== undefined}
                                         showIcon={true}
                                         noContentMessage={noSearchMessage}>
                            {
                                bookingVariants.length > 0 &&
                                <BookingVariantsList bookingVariants={bookingVariants}
                                                     accommodations={accommodations}/>
                            }
                            {
                                flexDateBookingVariants.length > 0 &&
                                <BookingVariantsList bookingVariants={flexDateBookingVariants}
                                                     accommodations={accommodations}
                                                     flexDate/>
                            }

                            <PriceList availableAccommodationUnitPrices={availableAccommodationUnitPrices}
                                       accommodations={accommodations}/>
                        </OptionalContent>
                    </LoadingOverlay>
                </CardContent>
            </Card>
        </Container>
    )
}


export default Availabilities;